import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import { RepositoryFactory } from "repository/RepositoryFactory";
import axios from "axios";
import moment from "moment";

// export const getWalletTransaction =
//   (id, lastDocument, onComplete = () => {}) =>
//   async (dispatch) => {
//     let querya = firebase
//       .firestore()
//       .collection("wallet_logs")
//       .where("userId", "==", id)
//       .orderBy("createdAt", "desc");
//     if (lastDocument != "") {
//       querya = querya.startAfter(lastDocument);
//     }
//     querya
//       .limit(10)
//       .get()
//       .then(async (query) => {
//         let temp_data = [];
//         for await (let doc of query.docs) {
//           if (doc.data()?.athleteId) {
//             let athlete = await firebase
//               .firestore()
//               .collection("users")
//               .doc(doc.data()?.athleteId)
//               .get();
//             temp_data.push({ data: doc.data(), athlete: athlete.data() });
//           } else {
//             let userId = await firebase
//               .firestore()
//               .collection("users")
//               .doc(doc.data()?.userId)
//               .get();
//             temp_data.push({ data: doc.data(), athlete: userId.data() });
//           }
//         }
//         console.log(temp_data);
//         let hasMoreDocument = temp_data.length >= 10;
//         if (lastDocument != "") {
//           dispatch({
//             type: "GET-WALLET-TRANSACTION",
//             payload: {
//               temp_data,
//               hasMoreDocument,
//               lastDocument: query.docs[temp_data.length - 1],
//             },
//           });
//         } else {
//           dispatch({
//             type: "GET-WALLET-TRANSACTION-EMPTY",
//             payload: {
//               temp_data,
//               hasMoreDocument,
//               lastDocument: query.docs[temp_data.length - 1],
//             },
//           });
//         }
//         onComplete();
//       });
//   };
export const getOnlyWalletTransaction =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = firebase
      .firestore()
      .collection("wallet_logs")
      .where("userId", "==", id)
      .where("paymentType", "==", "wallet");
    // .orderBy("paymentType", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          if (doc.data()?.athleteId) {
            let athlete = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data()?.athleteId)
              .get();
            temp_data.push({ data: doc.data(), athlete: athlete.data() });
          } else {
            let userId = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data()?.userId)
              .get();
            temp_data.push({ data: doc.data(), athlete: userId.data() });
          }
        }
        console.log(temp_data);
        let hasMoreDocument = temp_data.length >= 10;
        if (lastDocument != "") {
          dispatch({
            type: "GET-WALLET-TRANSACTION",
            payload: {
              temp_data,
              hasMoreDocument,
              lastDocument: query.docs[temp_data.length - 1],
            },
          });
        } else {
          dispatch({
            type: "GET-WALLET-TRANSACTION-EMPTY",
            payload: {
              temp_data,
              hasMoreDocument,
              lastDocument: query.docs[temp_data.length - 1],
            },
          });
        }
        onComplete();
      });
  };
///
export const getOtherWalletTransaction =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let querya = firebase
      .firestore()
      .collection("wallet_logs")
      .where("userId", "==", id)
      .where("paymentType", "!=", "wallet");
    // .orderBy("paymentType", "desc");
    if (lastDocument != "") {
      querya = querya.startAfter(lastDocument);
    }
    querya
      .limit(10)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          if (doc.data()?.athleteId) {
            let athlete = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data()?.athleteId)
              .get();
            temp_data.push({ data: doc.data(), athlete: athlete.data() });
          } else {
            let userId = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data()?.userId)
              .get();
            temp_data.push({ data: doc.data(), athlete: userId.data() });
          }
        }
        console.log(temp_data);
        let hasMoreDocument = temp_data.length >= 10;
        if (lastDocument != "") {
          dispatch({
            type: "GET-OTHER-TRANSACTION",
            payload: {
              temp_data,
              hasMoreDocument,
              lastDocument: query.docs[temp_data.length - 1],
            },
          });
        } else {
          dispatch({
            type: "GET-OTHER-TRANSACTION-EMPTY",
            payload: {
              temp_data,
              hasMoreDocument,
              lastDocument: query.docs[temp_data.length - 1],
            },
          });
        }
        onComplete();
      });
  };
///
export const getTotalAmount = (id) => (dispatch) => {
  firebase
    .firestore()
    .collection("wallet")
    .where("userId", "==", id)
    .onSnapshot((query) => {
      if (query.docs.length > 0) {
        dispatch({
          type: "GET-TOTAL-AMOUNT",
          payload: query.docs[0].data(),
        });
      } else {
        dispatch({
          type: "GET-TOTAL-AMOUNT",
          payload: 0,
        });
      }
    });
};

export const getAttachedAthlete =
  (id, onComplete = () => {}) =>
  () => {
    firebase
      .firestore()
      .collection("users")
      .where("role", "==", "athlete")
      .where("schoolAdminId", "==", id)
      .get()
      .then((query) => {
        console.log(query.docs.length);
        onComplete(query.docs.length);
      });
  };

export const withdrawRequest =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const withdrawRepository = RepositoryFactory.get("setWithdraw");
      await withdrawRepository.setWithdraw({
        amount: data.amount,
        userId: data.userId,
      });
      toast.success("Withdrawl request sucessfully");
      onComplete();
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      onComplete();
    }
  };

export const toUpWalletAmount =
  (data, email, onComplete = () => {}) =>
  async (dispatch) => {
    let newData = {
      amount: 0,
      topupAmount: data.schoolAmount,
      userId: data.userId,
    };
    await firebase
      .firestore()
      .collection("wallet")
      .where("userId", "==", data.userId)
      .get()
      .then(async (query) => {
        if (query.docs.length > 0) {
          await firebase
            .firestore()
            .collection("wallet")
            .doc(query.docs[0].id)
            .update({
              topupAmount: firebase.firestore.FieldValue.increment(
                data.schoolAmount
              ),
            });
        } else {
          await firebase.firestore().collection("wallet").add(newData);
        }
      });
    await firebase.firestore().collection("wallet_logs").add(data);
    toast.success("Top Up successfully");
    dispatch(sendReceiptEmail({ amount: data.schoolAmount, email: email }));
    onComplete();
  };

export const cashbackDataUpLoad =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const ticketsRepository = RepositoryFactory.get("setTickets");
      const response = await ticketsRepository.setTickets(data);
      console.log("===>", response);
      if (response.data.success) {
        dispatch({
          type: "TICKET_RESPONSE",
          payload: response?.data?.data,
        });
        onComplete("success");
      } else {
        onComplete("error");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log(error);
      onComplete();
    }
  };

export const schoolTicketData =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("fan_cash_back")
      .where("schoolAdminId", "==", id)
      .onSnapshot(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          let fan = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fanId)
            .get();
          temp_data.push({
            ...doc.data(),
            fan: fan.data(),
          });
        }
        dispatch({
          type: "GET_CASHBACK_DATA",
          payload: temp_data,
        });
        onComplete();
      });
  };

export const checkSchoolContract =
  (email, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("schoolContracts")
      .where("email", "==", email)
      .get()
      .then(async (query) => {
        console.log(query);
        if (query.empty) {
          onComplete("empty");
        } else {
          onComplete(query.docs[0].data());
        }
      });
  };

export const sendReceiptEmail = (data) => () => {
  let athleteResponseEmailNew = `This receipt acknowledges a deposit of ${
    data.amount
  }$ into your school’s PayPal account at FansHelpPlayers.com on ${moment().format(
    "DD/MM/YYYY"
  )} These funds will be used to fulfill your school’s stated wishes and obligations per the terms of your school’s contract with FansHelpPlayers, LLC in accordance with the data you have provided.`;
  const options = {
    to: [data.email, "testadmin@gmail.com"],
    subject: "Receipt for deposit ",
    text: athleteResponseEmailNew,
  };
  axios.post(
    "https://us-central1-fans-help-players.cloudfunctions.net/app/sendUserEmail",
    options
  );
};
